// CACHE_KEYS
export const CACHE_FOR_ONE_HOUR_IN_SECONDS = 60 * 60;
export const CACHE_FOR_ONE_DAY_IN_SECONDS = 60 * 60 * 24;
